import { render, staticRenderFns } from "./edit_platform.vue?vue&type=template&id=c55d3ebc&scoped=true&"
import script from "./edit_platform.vue?vue&type=script&lang=js&"
export * from "./edit_platform.vue?vue&type=script&lang=js&"
import style0 from "./edit_platform.vue?vue&type=style&index=0&id=c55d3ebc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55d3ebc",
  null
  
)

export default component.exports